import React, { useState, useEffect } from "react";
import axios from "axios";
import { useWeb3React } from "@web3-react/core";
import Header from "../Components/Header/Header";
import Footer from "../Components/Footer/Footer";
// import pdf from "../Files/META RANPO.pdf";
import pdf from "../Files/META.pdf";
import Card from "../Components/Card/Card";
import useToken from "../Hooks/useToken";
import Web3 from "web3";
import { getWalletBalance } from "../Utils/contractHelper";
import { web3_ } from "../Services";
import { TokenBalance } from "../Utils/contractHelper";
import { Salestatus } from "../Utils/contractHelper";
import { GetICOtoken, GetUserToken } from "../Utils/contractHelper";
import ScrollAnimation from "react-animate-on-scroll";
import { BsTwitter } from "react-icons/bs";
import { FaDiscord } from "react-icons/fa";
import { BsTelegram } from "react-icons/bs";
import ParticelBackground from "../Components/ParticelBackground";
import { BsFacebook } from "react-icons/bs";
import { RPC } from "../Config/constant";

import {
  GetICOStatus,
  GetApproveStatus,
  GetHardCapStatus,
  GetAllowance,
  GetUserPresale,
} from "../Utils/contractHelper";
import Swal from "sweetalert2";
import BigNumber from "bignumber.js";
import moment from "moment";

// import getWalletBalance from

const FeatureData = [
  {
    icon: "Mobile",
    path: process.env.PUBLIC_URL + "assets/images/Mobile.svg",
    title: "Mobile Application",
    text: "BEEPBOP will be available on iOS App Store and Google Play Store (Restricted to certain Country)",
  },
  {
    icon: "Earn",
    path: process.env.PUBLIC_URL + "assets/images/Earn.svg",
    title: "Post-to-Earn",
    text: "Users can post Photos or Videos and earn from the number of views, likes and share. User can burn token to boost post, level up and customize account",
  },
  {
    icon: "Share",
    title: "Pay-to-Share",
    path: process.env.PUBLIC_URL + "assets/images/Share.svg",
    text: "Users can sell original photo/video content in marketplace",
  },
  {
    icon: "Post-to-Earn",
    path: process.env.PUBLIC_URL + "assets/images/Metamask.svg",
    title: "Metamask Integration",
    text: "Users can deposit and send Cryptocurrencies to the wallet to fund their spending accounts",
  },
];
const ProjectHighLight = [
  {
    title: "Crypto Experiene",
    text: "BEEPBOP builds a full ecosystem vertical including wallet integration, swap and marketplace so, that the app is intuitive to use.",
  },
  {
    title: "Onboarding non-crypto users",
    text: "Pre-account unable non-cryto user to try for free and once they have enough tokens earned from the referral system, they can buy regular to premium account and start their crypto journey.",
  },
  {
    title: "Friendly to all kinds to people",
    text: "All types of accounts are designed to be user friendly, user can choose regular to premiumaccounts to have more engagements or audience.",
  },
  {
    title: "Available on iOS/Android:",
    text: "Users can download BEEPBOP from iOS AppStore and Google Play Store.",
  },
];
const Products = [
  {
    title: "BEEPBOP Account (Post-to-Earn):",
    text: "User can start posting video content and start earning reward tokens.",
  },
  {
    title: "Burning reward tokens:",
    text: "User can pay reward tokens to other user if they want other user to share their video content and to have more engagements/ views. If user #1likes the video content of user #2, user #2 will earn rewards tokens deducted from the wallet of user #1.",
  },
  {
    title: "Boosting and Ads:",
    text: "Users can boost their video content to BEEPBOP App to get more engagement/views. For businesses, BEEPBOP offers paid Ads and get a crypto oriented audience.",
  },
  {
    title: "NFT Marketplace:",
    text: "User can sell their video content on marketplace.",
  },
];

const Mainpage = () => {
  const { library, account, active, chainId } = useWeb3React();
  const [showModal, setShowModal] = useState(false);
  const [number, setNumber] = useState(null);
  const [number1, setNumber2] = useState(null);
  const [number3, setNumber3] = useState(null);
  const [BNBbalance, setBNBbalance] = useState();
  // const [starttime, setStarttime] = useState();
  const [icostatus, setICOStatus] = useState();
  const [isApprove, setisApprove] = useState(false);
  const [ICOtoken, setICOtoken] = useState();
  const [userToken, setUsertoken] = useState();
  const [UsdtPrice, setUsdtPrice] = useState();
  const [Userpresale, setUserPresale] = useState();
  const [hardcap, setHardcap] = useState();
  const [Sale, setSale] = useState();
  const [approvestatus, setApproveStatus] = useState();
  const [allowance, setAllowance] = useState();
  const [Getdetail, Setgetdetails] = useState();
  const [isValue, setIsValue] = useState(0);

  const { BuyToken } = useToken();

  useEffect(async () => {
    if (active) {
      console.log("hello");
      fetch("https://cex.io/api/last_price/USDT/USD")
        .then((res) => res.json())
        .then((data) => {
          console.log(data);
          setUsdtPrice(parseFloat(data.lprice));
        })
        .catch((err) => console.log(err));

      new web3_.eth.getBalance(account).then((res) => setBNBbalance(res));

      setICOStatus(await GetICOStatus(RPC));
      setICOtoken(await GetICOtoken(RPC));

      setUsertoken(await GetUserToken(library.provider, account));

      setHardcap(await GetHardCapStatus(RPC));
      setUserPresale(await GetUserPresale(RPC));
      setApproveStatus(await GetApproveStatus(RPC));
      setAllowance(await GetAllowance(RPC, account));
      setSale(await Salestatus(RPC));
    }
  }, [active, account]);

  const SalesData = [
    {
      title: "TOKEN NAME",
      value: "Project Hammada Token",
    },
    {
      title: "TOKEN SYMBOL",
      value: "PPT",
    },
    {
      title: "TOKEN TYPE",
      value: "BEP20 (BSC)",
    },
    {
      title: "TOTAL TOKEN SUPPLY",
      value: "100,000,000",
    },
    {
      title: "PRIVATE SALE ALLOCATION",
      value: "20,000,000",
    },

    {
      title: "COMPANY EXPENSES",
      value: "10,000,000",
    },

    {
      title: "PUBLIC SALE ALLOCATION",
      value: "50,000,000",
    },
    {
      title: "TREASURY",
      value: "20,000,000",
    },
  ];

  const Approve = async () => {
    await GetApproveStatus(library.provider)
      .send({
        from: account,
      })
      .then((res) => {
        console.log(res);
        setisApprove(true);
        // Swal.fire("Transaction Successful", "", "success");
      });
  };

  const Buy = async () => {
    let Presalefirst = number / parseFloat(Userpresale[0] / Math.pow(10, 18));
    let Presalesecond = number / parseFloat(Userpresale[1] / Math.pow(10, 18));

    if (active) {
      if (number > 0) {
        if (!icostatus) {
          if (
            parseInt(Sale[0]) <= parseInt(new Date().getTime() / 1000) &&
            Sale[1] >= parseInt(new Date().getTime() / 1000)
          ) {
            {
              await BuyFunction(Presalefirst);
            }
          } else if (
            parseInt(Sale[2]) <= parseInt(new Date().getTime() / 1000) &&
            Sale[3] >= parseInt(new Date().getTime() / 1000)
          ) {
            await BuyFunction(Presalesecond);
          } else {
            Swal.fire("Please wait for ICO to start");
          }
        } else {
          Swal.fire("ICO already end.");
        }
      } else {
        Swal.fire("USDT Token can not be zero");
      }
    } else {
      Swal.fire("Please connect to the wallet");
    }
  };

  const BuyFunction = async (Presalefirst) => {
    if (parseInt(allowance) >= parseFloat(number)) {
      if (parseInt(ICOtoken) / Math.pow(10, 14) >= Presalefirst) {
        if (parseInt(userToken) > 0) {
          let str = `${number * Math.pow(10, 18)}`;

          await BuyToken(
            new Web3().utils.toWei(number.toString(), "ether"),
            library.provider
          )
            .send({
              from: account,
            })
            .then((res) => {
              console.log(res);
              Swal.fire("Transaction Successful", "", "success");
            });
        } else {
          Swal.fire("You don't have enough USDT token");
        }
      } else {
        Swal.fire("ICO have not sufficient MRO balance");
      }
    } else {
      Swal.fire("Do not have sufficient allowance");
    }
  };
  return (
    <div>
      <>
        <Header />
        {/* <ParticelBackground /> */}
        {/* Section 1 start  */}
        <div>
          <section className="flex justify-center w-full max-w-[1300px] mx-auto px-[30px] md:px-[100px] md:pt-[90px] py-[80px]">
            <div className="flex flex-col md:flex-row gap-3 items-center pt-[50px]">
              <div className="text-left pt-[20px] flex-1">
                <div className="mb-[20px]">
                  <div className="mb-[10px]">
                    <h1 className="text-4xl">META RANPO</h1>
                  </div>
                  <p className="text-[18px] font-[300] text-xl font-base ">
                    The most trusted metaverse platform A special platform where
                    all your assets are secured and protected
                  </p>
                </div>
                <div className="flex flex-wrap flex-col md:flex-row  gap-4 items-center font-semibold">
                  <div className="max-w-[250px] w-full text-center border rounded-full  px-[32px] py-[16px] text-[16px] bg-[#EA6F0B] text-black cursor-pointer ">
                    <a href={pdf} target="blank">
                      WHITEPAPER
                    </a>
                  </div>
                  <div
                    onClick={() => {
                      active
                        ? setShowModal(true)
                        : Swal.fire("Please connect wallet");
                    }}
                    className="border-2 max-w-[250px] w-full text-center border-[#EA6F0B] rounded-full  px-[32px] py-[16px] text-[16px] cursor-pointer "
                  >
                    BUY TOKEN NOW
                  </div>
                </div>
              </div>
              <div className="flex-1 ">
                <img
                  className="ball"
                  width="100%"
                  src={process.env.PUBLIC_URL + "assets/images/hero-01.svg"}
                  alt="right-hero-img"
                ></img>
              </div>
            </div>
          </section>

          {/* Box Presale Rate */}
          <div className="flex justify-center">
            <h1 className="text-2xl uppercase">Stages of selling</h1>
          </div>
          <section className="flex flex-wrap gap-3 justify-center w-full max-w-[1300px] mx-auto px-[30px] md:px-[100px] md:pt-[30px] py-[30px]">
            <div className="w-full md:max-w-[400px]">
              <h1 className="mb-4 text-xl">Phase 1</h1>
              <div className="border-4 border-[#EA6F0B] rounded-md py-[3rem] px-5">
                <h1 className="mt-1 mb-2">
                  Sale starts Jan. 10th to Jan. 20th, 2023 on the MRO website
                  with an initial amount of 0.00000025 USDT
                </h1>

                <div class="flex m-auto gap-2 items-center w-[250px] ">
                  <input
                    type="number"
                    // isValue === 0 ? "" : parseInt(isValue)
                    value={number1 === 0 ? "" : parseInt(number1)}
                    min="1"
                    onChange={(e) => setNumber2(e.target.value)}
                    class="shadow appearance-none border rounded w-full py-2 px-1 text-black"
                  />
                  {/* <span class="font-bold ">USDT</span> */}
                </div>
                <h1 className="mt-1 mb-2">
                  {/* {parseInt(isValue) > 1 ? `Rooms` : `Room`} */}
                  Amount = {(number1 ? number1 : 0) / 0.00000025} MRO
                </h1>
              </div>
            </div>

            <div className="w-full md:max-w-[400px]">
              <h1 className="mb-4 text-xl">Phase 2</h1>
              <div className="border-4 border-[#EA6F0B] rounded-md py-[3rem] px-5">
                <h1 className="mt-1 mb-2">
                  Sale is start Jan. 21st to Jan. 31st, 2023 on the MRO website
                  with initial amount 0.000003 USDT
                </h1>
                <div class="flex m-auto gap-2 items-center w-[250px] ">
                  <h1></h1>
                  <input
                    type="number"
                    value={number3 === 0 ? "" : parseInt(number3)}
                    min="1"
                    onChange={(e) => setNumber3(e.target.value)}
                    class="shadow appearance-none border rounded w-full py-2 px-1 text-black"
                  />
                  {/* <span class="font-bold ">USDT</span> */}
                </div>
                <h1 className="mt-1 mb-2">
                  Amount = {(number3 ? number3 : 0) / 0.000003} MRO
                </h1>
              </div>
            </div>
          </section>

          <div className="m-auto text-center">
            <h1 className="mb-4 text-xl mt-4">Phase 3</h1>
          </div>
          <section className="flex flex-wrap gap-3 justify-center w-full max-w-[1200px] mx-auto px-[30px] md:px-[100px] md:pt-[30px] py-[30px]">
            <div className="flex  gap-2 ">
              <div className="flex  flex-wrap gap-2 border-4 border-[#EA6F0B] rounded-md py-[3rem] px-5  w-full md:max-w-[400px] ">
                <div class="items-center ">
                  <p>
                    The third stage, from 1st February to 15th February, 2023 on
                    coinsniper and pinksale Then on March 1, 2023, the sale
                    begins on coinmarketcap, coingecko, and pancakeswap
                  </p>
                </div>
              </div>
              {/* <div className="flex flex-1 gap-2 border-4 border-[#EA6F0B] rounded-md py-[3rem] px-5 w-full md:max-w-[400px]">
                <div class="items-center">
                  <p>
                    Last but not least, selling via Pancake Swap at 0.0000015
                    USDT
                  </p>
                </div>
              </div> */}
            </div>
          </section>
          {/* Close Box */}

          {/* Token Section */}

          <section
            className="  justify-center w-full max-w-[1300px] mx-auto px-[30px] md:px-[100px] md:pt-[75px] py-[30px]"
            id="tokenomics"
          >
            <div className="flex  justify-center text-center text-2xl pt-[50px] uppercase">
              Tokenomics
            </div>
            <img
              className="flex m-auto"
              src={process.env.PUBLIC_URL + "assets/images/chart.svg"}
              width="100%"
            ></img>
          </section>
          {/* Close Token */}

          {/* Secure Section */}
          <section
            className="w-full max-w-[1300px] mx-auto px-[30px] md:px-[90px] md:pt-[7.5rem] py-[30px]"
            id="security"
          >
            <div className="text-center m-auto text-2xl">
              <h1>WE ARE SECURE!</h1>
            </div>
            <div className="flex justify-center m-auto text-center text-xl mt-5">
              The most trusted metaverse platform<br></br>A special platform
              where all your assets are secured and protected
            </div>
            <div className="text-center m-auto w-full md:w-[750px]">
              <img
                width="100%"
                src={process.env.PUBLIC_URL + "assets/images/secure.svg"}
                alt="right-hero-img"
              ></img>
            </div>
          </section>
          {/* close Secure */}

          {/* Ecosystem */}
          <ScrollAnimation animateIn="fadeIn">
            <section
              className="w-full max-w-[1300px] mx-auto px-[30px] md:px-[90px] md:pt-[3rem] py-[30px]"
              id="ecosystem"
            >
              <div className="text-center text-2xl mt-5 mb-4">
                <h1>META RANPO ECOSYSTEM</h1>
              </div>
              <span className="text-center m-auto mt-5 text-xl mt-5">
                As an NFT based organization that operates according to
                pre-written business rules and processes, without the need for
                any centeral authority or intermediaries. This means that the
                organization can operate autonomously and without bias, as all
                decision-making will be performed by its community of token
                holders. This ensures that funds are ditributed transparently
                and in a fair, unbiased manner.
              </span>
              <div>
                <img
                  className="flex m-auto"
                  src={process.env.PUBLIC_URL + "assets/images/METANFT.svg"}
                  width="70%"
                ></img>
              </div>
            </section>
          </ScrollAnimation>
          {/* close Ecosystem */}

          <section className="pt-[5rem] mb-5">
            <h1
              className="flex m-auto justify-center items-center text-2xl"
              id="roadmap"
            >
              ROADMAP
            </h1>
            <div class="max-w-[1300px] mx-auto flex  ">
              <div class="flex flex-col md:grid grid-cols-9 mx-auto p-2">
                <div class="flex flex-row-reverse md:contents">
                  <div class="w-full col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto border border-[#EA6F0B]">
                    <h3 class="font-semibold text-2xl mb-5 text-white  ">
                      THE FIRST QUARTER OF 2023
                    </h3>
                    <p class="text-white text-xl mb-2">
                      A pre-sale sale was established in 3 stages:
                    </p>

                    <ul className="list-disc pl-3  text-start">
                      <li className="">
                        The first phase from January 10, 2023 to the 20th of the
                        same month
                      </li>
                      <li>
                        The second stage, from January 21, 2023 to the 31st of
                        the same month On the MRO website
                      </li>
                      <li>
                        The third stage, from February 1, 2023 to the 15th of
                        the same month, on coinsniper and pinksale Then on March
                        1, 2023, the sale begins on coinmarketcap, coingecko,
                        and pancakeswap
                      </li>
                    </ul>
                  </div>

                  <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>
                </div>

                <div class="flex md:contents">
                  <div class="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>

                  <div class="w-full col-start-6 col-end-10  p-4 border border-[#EA6F0B] rounded-xl  flex flex-col justify-start">
                    <h3 class="font-semibold text-2xl mb-5 text-white capitalize">
                      The SECOND QUARTER OF 2023
                    </h3>
                    <ul className="list-disc text-white text-xl pl-2 text-start">
                      <li>MRO website development.</li>
                      <li class=" mt-2">
                        Issuance of NFTs Selling on the site at a price ranging
                        between 50 to 75 dollars for the full pieces, where each
                        piece contains a number of MRO coins.
                      </li>
                      <li class=" mt-2">
                        Burning a billion of Altotal Supply.
                      </li>

                      <li class=" mt-2">
                        Take monthly pictures of the largest token-bearing
                        wallets. (100)
                      </li>
                      <li class="mt-2">
                        Listings on two platforms of Top 100.
                      </li>
                    </ul>
                  </div>
                </div>

                <div class="flex flex-row-reverse md:contents">
                  <div class="w-full col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto border border-[#EA6F0B]">
                    <h3 class="font-semibold text-xl mb-1 text-white capitalize">
                      THIRD QUARTER OF 2023
                    </h3>
                    <ul className=" text-white text-xl list-disc pl-2 text-start">
                      <li>MRO game launch</li>
                      <li>
                        MRO game launchBurning a billion of Altotal Supply.
                      </li>
                      <li>
                        Take monthly pictures of the largest token-bearing
                        wallets. (100)
                      </li>
                      <li>Take a picture of the top 50 players.</li>
                      <li>
                        Take a picture of the top 100 wallets holding NFTs
                      </li>
                      <li>Listings on two platforms of Top 75</li>
                    </ul>
                  </div>

                  <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>
                </div>

                <div class="flex md:contents">
                  <div class="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>

                  <div class="w-full col-start-6 col-end-10 my-4 mr-auto p-4 border border-[#EA6F0B] rounded-xl">
                    <h3 class="font-semibold text-xl mb-1 text-white">
                      THE FOURTH QUARTER OF 2023
                    </h3>
                    <ul class="text-white list-disc pl-2 text-start ">
                      <li className="mt-2 text-xl">Launch of the MRO wallet</li>
                      <li className="mt-2 text-xl">
                        Where to obtain percentages ranging from 100% to 10%
                      </li>
                      <li className="mt-2 text-xl">
                        The number of tokens deposited in the wallet
                      </li>
                      <li className="mt-2 text-xl">
                        Burning a billion of Altotal Supply.
                      </li>
                      <li className="mt-2 text-xl">
                        Take monthly pictures of the largest token-bearing
                        wallets. (100)
                      </li>
                      <li className="mt-2 text-xl">
                        Take a picture of the top 50 players
                      </li>
                      <li className="mt-2 text-xl">
                        Take a picture of the top 100 wallets holding NFTs
                      </li>
                      <li className="mt-2 text-xl">
                        Listings on two platforms of Top 50
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="flex flex-row-reverse md:contents">
                  <div class="w-full col-start-1 col-end-5 p-4 rounded-xl my-4 ml-auto border border-[#EA6F0B]">
                    <h3 class="font-semibold text-xl mb-1 text-white">
                      THE FIRST QUARTER OF 2024
                    </h3>
                    <ul class="text-white list-disc pl-2 text-start">
                      <li className="text-xl mt-2">
                        Distributing a percentage between 10 to 15% cash bonus
                        and 10 to 15% coins for those who have kept the code for
                        a year, and the distribution will continue according to
                        annual profits.
                      </li>
                      <li className="text-xl mt-2">
                        Burning a billion of Altotal Supply.
                      </li>
                      <li className="text-xl mt-2">
                        Take monthly pictures of the largest token-bearing
                      </li>
                    </ul>
                  </div>

                  <div class="col-start-5 col-end-6 md:mx-auto relative mr-10">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>
                </div>

                <div class="flex md:contents">
                  <div class="col-start-5 col-end-6 mr-10 md:mx-auto relative">
                    <div class="h-full w-6 flex items-center justify-center">
                      <div class="h-full w-0.5 bg-[#EA6F0B] pointer-events-none"></div>
                    </div>

                    <div class="w-6 h-6 absolute top-1/2 -mt-3 border-2 border-[#EA6F0B] rounded-full bg-[#EA6F0B] shadow"></div>
                  </div>

                  <div class="w-full col-start-6 col-end-10 my-4 mr-auto p-4 border border-[#EA6F0B] rounded-xl">
                    <h3 class="font-semibold text-xl mb-1 text-white">
                      THE SECOND QUARTER OF 2024
                    </h3>
                    <span className="text-white text-xl">
                      A very big ceremony will take place, God willing, on the
                      passage of the first year of the birth of the symbol Prize
                      distribution:
                    </span>
                    <ul class="text-white list-disc pl-2 text-start ">
                      <li className="mt-2 text-xl">
                        Top 100 token-bearing wallets for the last 6 months.
                      </li>
                      <li className="mt-2 text-xl">
                        The largest 100 wallets holding NFTs.
                      </li>
                      <li className="mt-2 text-xl">
                        Code holder for the last 6 months ago.
                      </li>
                      <li className="mt-2 text-xl">Top 100 MRO players.</li>
                      <li className="mt-2 text-xl">
                        Code holder for the last 6 months ago
                      </li>
                      <p className="mt-2 text-xl">
                        The prizes will be: (Cars + phones + gold + leading
                        digital currencies) in the most famous hotels
                      </p>
                      <li className="mt-2 text-xl">
                        Monthly photos and quarterly burning of one billion and
                        percentages of cash and in-kind grants will be taken
                        every calendar year
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Team section */}
          <section
            className="w-full max-w-[1300px] mx-auto px-[30px] md:px-[90px] md:pt-[2rem] py-[30px]"
            id="team"
          >
            <h1 className="items-center text-2xl mb-5 ">OUR TEAM</h1>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              <div className="team-item">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    src="https://png.pngtree.com/png-vector/20190710/ourmid/pngtree-user-vector-avatar-png-image_1541962.jpg"
                    width="100%"
                  ></img> */}
                </div>
                <p className="text-xl mt-2">H&H&A</p>
                <p className="text-xl mt-2">Founder</p>

                {/* <p className="text-base mt-2 text-start">
                  He held the position of general manager of production in
                  several media organisations For 8 years, he founded the media
                  production company, Cartoon for Children until 2020 Then he
                  switched to Blockchain and Metaverse
                </p> */}
                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
                {/* <div class="tooltip mt-5 text-xl">
                  About me
                  <span class="tooltiptext mr-5">
                    He held the position of general manager of production in
                    several media organisations For 8 years, he founded the
                    media production company, Cartoon for Children until 2020
                    Then he switched to Blockchain and Metaverse
                  </span>
                </div> */}
              </div>

              <div className="team-item">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    width="100%"
                    src={process.env.PUBLIC_URL + "assets/images/ali.jpg"}
                  ></img> */}
                </div>
                <p className="text-xl mt-2">Ali Awais</p>
                <p className="text-xl mt-2">Project Manager </p>
                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
                {/* <div class="tooltip mt-5 text-xl">
                  About me
                  <span class="tooltiptext mr-5">
                    Work as an assistant to the founder in production
                    institutions Then he became the general manager of the
                    founder’s company until he returned to complete his
                    university studies in …………………
                  </span>
                </div> */}
              </div>

              <div className="team-item">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    src={process.env.PUBLIC_URL + "assets/images/OULU1.jpg"}
                    width="100%"
                  ></img> */}
                </div>
                <p className="text-xl mt-2">Olo Fisher</p>
                <p className="text-xl mt-2">Production Manager </p>
                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
                {/* <div class="tooltip mt-5 text-xl">
                  About me
                  <span class="tooltiptext mr-5">
                    Director of Marketing, Partnerships and Sponsorships As
                    customers fondly call it, it is deeply rooted in research
                    and analysis. He has, through critical and strategic
                    thinking, provided immediate solutions to many seemingly
                    complex business problems over the past eight years. and
                    companies around the world, he has received many praises and
                    recommendations, excelling at creating and maintaining
                    business ideas and developing start-up businesses.
                  </span>
                </div> */}
              </div>

              <div className="team-item mt-3">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    src={process.env.PUBLIC_URL + "assets/images/RIYAZ.jpg"}
                    width="100%"
                  ></img> */}
                </div>
                <p className="text-xl mt-2">RIYAZ BEG</p>
                <p className="text-xl mt-2">Graphic & 3d Animation Designer</p>
                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
              </div>
              <div className="team-item mt-3">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    src={process.env.PUBLIC_URL + "assets/images/Gulam.jpg"}
                    width="100%"
                  ></img> */}
                </div>
                <p className="text-xl mt-2">Ghulam Jailani </p>
                <p className="text-xl mt-2">
                  Social media head (video developer)
                </p>

                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
                {/* <div class="tooltip mt-5 text-xl">
                  About me
                  <span class="tooltiptext mr-5">
                    He has professional skills in the technical Field, he has
                    more than 5 years experience as a technical director, he is
                    top rated on fiverr and Upwork.
                  </span>
                </div> */}
              </div>
              <div className="team-item mt-3">
                <div className="team-thumb">
                  {/* <img
                    className="flex m-auto rounded-full"
                    src={process.env.PUBLIC_URL + "assets/images/Sammar.jpg"}
                    width="100%"
                  ></img> */}
                </div>
                <p className="text-xl mt-2">Sammar</p>
                <p className="text-xl mt-2">
                  Translator and Communication manager
                </p>
                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
              </div>
              {/* <div className="team-item mt-3">
                <div className="team-thumb">
                  <img
                    className="flex m-auto rounded-full"
                    src={process.env.PUBLIC_URL + "assets/images/women.jpg"}
                    width="100%"
                  ></img>
                </div>
                <p className="text-xl mt-2">Kannapathi</p>
                <p className="text-xl mt-2">Graphic & 3d Animation Designer</p>

                <div className="flex gap-4  cursor-pointer text-center m-auto justify-center">
                  <a href="https://www.facebook.com/profile.php?id=100089037518319">
                    <BsFacebook
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://discordapp.com/users/1053735494242025595">
                    <FaDiscord
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                  <a href="http://t.me/metaranpo11">
                    <BsTelegram
                      style={{ fontSize: "1.5em", color: "#EA6F0B" }}
                    />
                  </a>
                </div>
                <div class="tooltip mt-5 text-xl">
                  About me
                  <span class="tooltiptext mr-5">
                    Kannapathi is Responsible for 3D graphics and graphics
                    development. He worked from the beginning under the
                    responsibilities of the founder as a draftsman in media
                    institutions, then moved to the production company and is
                    still associated with the founder.
                  </span>
                </div>
              </div> */}
            </div>
          </section>
          {/* Close Team */}

          {/* Founder words */}
          <section
            className="w-full max-w-[1300px] mx-auto px-[30px] md:px-[90px] md:pt-[3rem] py-[30px]"
            id="founder"
          >
            <h1 className="text-center m-auto text-2xl">FOUNDER WORDS</h1>
            <span className="text-xl text-white text-start mt-4">
              Dear user, <br></br>The idea of this symbol and game is purely for
              entertainment, and to raise awareness about life’s transformation
              and rapid progress. We present it as a gift to you and we are open
              to your contributions as to how the game can be more interactive
              and overall beneficial to all. Warm greetings to you!
            </span>
          </section>
          {/* Close founder words */}

          {showModal ? (
            <>
              <div className="flex justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
                <div className="relative w-auto my-6 mx-auto max-w-3xl">
                  <div className="md:w-[30rem] w-full border rounded-lg shadow-lg relative flex flex-col w-full bg-[#000] outline-none focus:outline-none popmodel border-2 border-[#FFD51E]">
                    <div className="flex items-start justify-between p-5 border-b border-solid border-[#9C045D] rounded-t bg-[#FFD51E]">
                      <h3 className="text-3xl font-semibold text-black">
                        Buy Token
                      </h3>
                      <button
                        className="bg-transparent border-0 text-black float-right"
                        onClick={() => setShowModal(false)}
                      >
                        <span className="text-black opacity-7 h-6 w-6 text-xl block  py-0 rounded-full">
                          x
                        </span>
                      </button>
                    </div>
                    <div className="relative p-6 flex-auto">
                      <div className=" shadow-md rounded px-8 pt-6 pb-8 w-full">
                        <label className="block text-wh text-sm font-bold mb-1 text-left mb-5">
                          Amount
                        </label>
                        <div className="flex gap-2 items-center ">
                          <input
                            type="number"
                            value={number === 0 ? "" : parseInt(number)}
                            min="1"
                            onChange={(e) => setNumber(e.target.value)}
                            disabled={isApprove}
                            className="shadow appearance-none border rounded w-full py-2 px-1 text-black"
                          />
                          <span className="font-bold ">USDT</span>
                        </div>
                      </div>
                    </div>

                    <div className="flex items-center justify-end p-6 border-t border-solid border-blueGray-200 rounded-b">
                      <button
                        className="text-white border-2 border-[#FFD51E]  font-bold uppercase text-sm px-6 py-3 rounded shadow hover:shadow-lg outline-none focus:outline-none mr-1 mb-1"
                        type="button"
                        // onClick={isApprove ? Buy : approve}
                        onClick={isApprove ? Buy : Approve}
                      >
                        {isApprove ? "Buy" : "Approve"}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </>
          ) : null}
        </div>
        <Footer />
      </>
    </div>
  );
};

export default Mainpage;
